package app.bloomey.web.modules.auth

import app.bloomey.web.core.data.models.ApiResponse
import app.bloomey.web.core.data.models.LoginRequest
import app.bloomey.web.core.data.models.LoginResponse
import app.bloomey.web.utils.ApiError
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import org.koin.core.component.KoinComponent
import org.koin.core.component.inject

class AuthApi : KoinComponent {
    private val client by inject<HttpClient>()
    suspend fun login(email: String, password: String): ApiResponse<LoginResponse> {
        val response = client.post("v1/admin/login") {
            setBody(LoginRequest(email = email, password = password))
            contentType(ContentType.parse("application/json"))
        }
        if (response.status.isSuccess()) {
            return response.body()
        } else
            throw ApiError(response.body<ApiResponse<String>>().data)
    }

}